import { useRef } from "react";

export default function SelectHighlighttext(props) {
    const textareaRef = useRef(null);
    return (
        <div className="flex flex-col w-full gap-[8px]">
            <textarea
                ref={textareaRef}
                className='bg-white min-h-[200px] rounded-[7px] p-[8px] w-full'
                value={props.value}
                placeholder='文字'
                disabled={true}
                onChange={(e) => { }}
            />
            <div className="w-full flex flex-row gap-[16px]">
                <button
                    className='bg-[#1F4CC8] text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]'
                    onClick={()=>{
                        if (textareaRef.current?.selectionStart == undefined || textareaRef.current?.selectionEnd === undefined) {
                            alert('請在上面的輸入欄位中選擇標記文字'); return
                        } if (textareaRef.current?.selectionStart === textareaRef.current?.selectionEnd) {
                            alert('請在上面的輸入欄位中選擇標記文字'); return
                        }
                        if (props.onSubmit) props.onSubmit(textareaRef.current?.selectionStart,textareaRef.current?.selectionEnd)
                    }}
                >
                    標記
                </button>
            </div>
        </div>
    )

}